'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _elementConstants = require('./elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Attachment Uploads
var findingIcon = function findingIcon(state, action) {
    return state.update('content', function (content) {
        return content.merge({ icon: { fetching: true } });
    });
};

var findingIconComplete = function findingIconComplete(state, action) {
    return state.update('content', function (content) {
        return content.merge({ icon: { fetching: false } });
    });
};

exports.default = function (state, action) {
    switch (action.type) {
        case TYPES.ELEMENT_ICON_FIND:
            return findingIcon(state, action);
        case TYPES.ELEMENT_ICON_FIND_SUCCESS:
        case TYPES.ELEMENT_ICON_FIND_FAILURE:
            return findingIconComplete(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementReducerIcons.js
// module id = 2268
// module chunks = 0